import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ReactSession } from "../../../../lib/secure_reactsession";
import { showToast } from "../../../../lib/helpers";
import { savePreferenceTestFollowupQuestions } from "../../../../services/test_result";
import GlobalQuestion from "../../global-question";

export default function PreferenceTestFollowUpQuestions({
    test,
    result,
    questionCallback,
    callback,
    questionType,
    timeSpent,
}) {
    const location = useLocation();
    const [isActiveQuestion, setActiveQuestion] = useState(null);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [QuestionArrayList, setQuestionArrayList] = useState([]);
    const [questionLoading, setQuestionLoading] = useState(false);
    const [questionArray, setQuestionArray] = useState([]);
    const [questionTimeSpend, setQuestionTimeSpend] = useState(0);
    const [skippedCount, setSkippedCount] = useState(0);
    const isActiveQuestionId = useRef(null);
    const isSkipped = useRef(0);
    const isOptional = useRef(false);
    const logicalySkipped = useRef(0);
    const isTyping = useRef(false);
    const [logicAdded, setLogicAdded] = useState(false);

    useEffect(() => {
        let Questions = [];
        if (questionType === "Preference Test Followup Questions") {
            if (test && test.preference_test_question.length) {
                setActiveQuestion(1);
                setTotalQuestion(test && test.preference_test_question.length);

                test &&
                    test.preference_test_question.forEach((items) => {
                        Questions.push({
                            data: items,
                            questionData: JSON.parse(items.questions),
                        });
                        if (JSON.parse(items.questions)["is_logic"] == 1) {
                            setLogicAdded(true);
                        }
                    });

                setQuestionArrayList(Questions);
                isOptional.current = Questions[0]['questionData']['is_optional'];
            } else {
                saveQuestionData([], true);
            }
        }

        window.scrollTo(0, 0);

        function tickTime() {
            setQuestionTimeSpend((prevSeconds) => prevSeconds + 1);
        }
        let timeData = setInterval(() => tickTime(), 1000);

        return () => clearInterval(timeData);
    }, []);

    const handleNextQuestion = (formData, shouldEndSurvey, jumpToQuestion) => {
        if (shouldEndSurvey) {
            saveQuestionData([...questionArray, formData], false);
            return;
        }

        // Store current question data before updating state
        const currentQuestion = QuestionArrayList[isActiveQuestion - 1];
        const nextQuestionIndex = jumpToQuestion ? jumpToQuestion - 1 : isActiveQuestion;
        const nextQuestion = QuestionArrayList[nextQuestionIndex];

        if (!nextQuestion) {
            // If there's no next question, save and end
            saveQuestionData([...questionArray, formData], false);
            return;
        }

        if (jumpToQuestion) {
            setActiveQuestion(jumpToQuestion);
            logicalySkipped.current = 1;
        } else {
            setActiveQuestion(isActiveQuestion + 1);
            logicalySkipped.current = 0;
        }

        setQuestionArray([...questionArray, formData]);
        setQuestionTimeSpend(0);
        isSkipped.current = 0;
        isTyping.current = false;
        isActiveQuestionId.current = nextQuestion.data.id;
        isOptional.current = nextQuestion.questionData.is_optional;

        // scroll to active questions
        const item = document.getElementById('scroll-follow-up-question-nxt-btn');
        if (item) {
            item.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    };

    const saveQuestionData = (formData, shouldNavigate) => {
        if (location.pathname.substr(1, 1) === "t") {
            let data = Object.assign({}, { questions: formData });
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["question_type"] = questionType;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;

            if (questionLoading) {
                return false;
            }

            if (!shouldNavigate) {
                setQuestionLoading(true);
            }

            if (shouldNavigate) {
                questionCallback(formData, questionType, false);
            }

            savePreferenceTestFollowupQuestions(data, ReactSession.get("token")).then(
                (response) => {
                    if (!shouldNavigate) {
                        setQuestionLoading(false);
                    }
                    if (response.success) {
                        callback();
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            callback();
        }
    };

    return (
        <>
            <div className="taking-test-page-wrap" id={'scroll-follow-up-question-nxt-btn'}>
                <div className="container">
                    {QuestionArrayList &&
                        QuestionArrayList.map((items, index) => {
                            return (
                                <div key={index}>
                                    {isActiveQuestion === index + 1 && (
                                        <GlobalQuestion
                                            test={test}
                                            question={items}
                                            currentStep={isActiveQuestion}
                                            totalSteps={QuestionArrayList.length}
                                            onNext={handleNextQuestion}
                                            onSkip={() => {
                                                if (skippedCount < 2) {
                                                    isSkipped.current = 1;
                                                    handleNextQuestion({
                                                        question_id: isActiveQuestionId.current,
                                                        is_skipped: 1
                                                    });
                                                }
                                            }}
                                            isOptional={items.questionData.is_optional}
                                            timeSpent={questionTimeSpend}
                                            questionType={questionType}
                                            result={result}
                                            questionCallback={questionCallback}
                                            callback={callback}
                                            methodology="preference"
                                            skippedCount={skippedCount}
                                            onSkipCountChange={setSkippedCount}
                                        />
                                    )}
                                </div>
                            );
                        })}
                </div>
            </div>
        </>
    );
}
